import type {
  CompetitionEventPublic,
  Schemas,
} from "@softmax/observatory-client/types";

import type { PlayTransport } from "./play-transport";
type MyEpisodesPage = Schemas["EpisodePage"];
type RoundEpisodesPage = Schemas["RoundEpisodePage"];
type MyExperienceRequestPage = Schemas["V2ExperienceRequestPage"];
export function createPlayEpisodeReads(transport: PlayTransport) {
  const { playFetch } = transport;
  const competitionEvents = ({
    playerId,
    limit,
  }: {
    playerId: string;
    limit: number;
  }): Promise<CompetitionEventPublic[] | null> => {
    const query = new URLSearchParams({
      player_id: playerId,
      limit: String(limit),
    });
    return playFetch<CompetitionEventPublic[]>({
      path: `/v2/competition-events?${query.toString()}`,
    });
  };
  const myEpisodes = ({
    policyVersionId,
    limit = 100,
    cursor = null,
  }: {
    policyVersionId: string;
    limit?: number;
    cursor?: string | null;
  }): Promise<MyEpisodesPage | null> => {
    const after =
      cursor === null ? "" : `&cursor=${encodeURIComponent(cursor)}`;
    return playFetch<MyEpisodesPage>({
      path: `/v2/policy-versions/${encodeURIComponent(policyVersionId)}/episodes?limit=${limit}${after}`,
    });
  };
  const roundEpisodes = ({
    roundId,
    limit = 20,
  }: {
    roundId: string;
    limit?: number;
  }): Promise<RoundEpisodesPage | null> => {
    return playFetch<RoundEpisodesPage>({
      path: `/v2/rounds/${encodeURIComponent(roundId)}/episodes?limit=${limit}&completed_only=true`,
    });
  };
  const myExperienceRequests = ({
    leagueId,
    limit = 1,
  }: {
    leagueId: string;
    limit?: number;
  }): Promise<MyExperienceRequestPage | null> => {
    const query = new URLSearchParams({
      mine: "true",
      league_id: leagueId,
      limit: String(limit),
    });
    return playFetch<MyExperienceRequestPage>({
      path: `/v2/experience-requests?${query.toString()}`,
    });
  };
  return { competitionEvents, myEpisodes, roundEpisodes, myExperienceRequests };
}
